import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OfficeService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getCompanies() {
    return this.http.get("/Office/GetCompanies").toPromise();
  }

  getForms(company: any, module: any) {
    return this.http.get("/Office/GetForms?co=" + company + "&module=" + module).toPromise();
  }

  getFormMetadata(tableName: any, company: any) {
    return this.http.get("/Office/GetFormMetadata?form=" + tableName + "&co=" + company).toPromise();
  }

  getFormData(tableName: any, company: any, orderby: any, keyid: any, rowsPerPage: any, pageNumber: any, where: any) {
    return this.http.get("/Office/GetData?form=" + tableName + "&co=" + company + "&rowsPerPage=" + rowsPerPage + "&pageNumber=" + pageNumber + orderby + "&keyid=" + keyid + where).toPromise();
  }

  insertUpdateData(co: any, form: any, formData: any, keyID: any) {
    return this.http.post("/Office/InsertUpdateData",
      {
        co: co,
        form: form,
        formData: formData,
        keyID: keyID,
      }).toPromise();
  }

  deleteRow(co: any, form: any, keyID: any) {
    return this.http.post("/Office/DeleteData",
      {
        co: co,
        form: form,
        keyID: keyID,
      }).toPromise();
  }

  getAttachmentList(co: any, form: any, keyID: any, UniqueAttchID: any) {
    return this.http.get("/Office/GetAttachmentList?co=" + co + "&form=" + form + "&keyID=" + keyID + "&UniqueAttchID=" + UniqueAttchID).toPromise();
  }

  insertAttachment(co: any, form: any, keyID: any, description: any, origFileName: any, attachmentTypeID: any, attachData: any) {
    return this.http.post("/Office/InsertAttachment",
      {
        co: co,
        form: form,
        keyID: keyID,
        description: description,
        origFileName: origFileName,
        attachmentTypeID: attachmentTypeID,
        attachData: attachData
      }).toPromise();
  }

  updateAttachmentMetadata(co: any, form: any, keyID: any, description: any, attachmentID: any, attachmentTypeID: any) {
    return this.http.post("/Office/UpdateAttachmentMetadata",
      {
        co: co,
        form: form,
        keyID: keyID,
        attachmentID: attachmentID,
        description: description,
        attachmentTypeID: attachmentTypeID,
      }).toPromise();
  }

  getAttachmentData(co: any, form: any, keyID: any, attachmentID: any) {
    return this.http.get("/Office/GetAttachmentData?co=" + co + "&form=" + form + "&keyID=" + keyID + "&attachmentID=" + attachmentID).toPromise();
  }

  deleteAttachment(co: any, form: any, keyID: any, attachmentID: any) {
    return this.http.post("/Office/DeleteAttachment",
      {
        co: co,
        form: form,
        keyID: keyID,
        attachmentID: attachmentID,
      }).toPromise();
  }

  getAttachmentTypes(co: any) {
    return this.http.get("/Office/AttachmentTypes?co=" + co).toPromise();
  }

  getFormItemGroups(form: any) {
    return this.http.get("/Office/GetFormItemGroups?form=" + form).toPromise();
  }

  getFormItemFields(form: any) {
    return this.http.get("/Office/GetFormItemFields?form=" + form).toPromise();
  }

  getFormReports(co: any, form: any) {
    return this.http.get("/Office/getFormReports?co=" + co + "&form=" + form).toPromise();
  }

  getLookup(co: any, form: any, seq: any, lookup: any, formData: any, searchString: any) {
    return this.http.post("/Office/getLookup", {
      co: co,
      form: form,
      seq: seq,
      lookup: lookup,
      formData: formData,
      searchString: searchString
    }).toPromise();
  }

  getStaticLookups(co: any, form: any) {
    return this.http.get("/Office/getStaticLookups?co=" + co + "&form=" + form).toPromise();
  }

  getVaInquiries(co) {
    return this.http.get("/Office/GetVaInquiries?co=" + co).toPromise();
  }

  getVaInquiryData(co, queryName, paramValues) {
    let url = "/Office/GetVaInquiryData?co=" + co + "&queryName=" + queryName;
    let params = "";
    for (let i = 0; i < paramValues.length; i++) {
      params += "&paramValues[" + i + "]=" + encodeURIComponent(paramValues[i]);
    }
    return this.http.get(url + params).toPromise();
  }

  getVaInquiryLookup(co, lookup, dependentData = null) {
    let url = "/Office/GetVaInquiryLookup?co=" + co + "&lookup=" + lookup;
    if (dependentData != null)
      url += "&dependentData=" + encodeURIComponent(dependentData);
    return this.http.get(url).toPromise();
  }

  getVaInquiryParameters(co, queryName) {
    return this.http.get("/Office/GetVaInquiryParameters?co=" + co + "&queryName=" + queryName).toPromise();
  }

  updateFormState(form, groups, fields) {
    let url = "/Office/UpdateFormState";
    let postData = {
      form: form,
      groups: groups,
      fields: fields
    }
    return this.http.post(url, postData).toPromise();
  }

  getExcelFile(tableName: any, company: any, orderby: any, keyid: any, where: any, columnInfo: any, fileName: any) {
    return this.http.post("/office/SaveExcelFile", {
      form: tableName,
      co: company,
      orderby: orderby,
      keyid: keyid,
      where: where,
      columns: columnInfo
    }).toPromise().then((response) => {
      if (response["success"] == false) {
        return false;
      }
      else {
        let url = "/Office/GetExcelFile?formName=" + tableName + "&fileName=" + fileName ?? tableName;
        window.location.href = url;
        return true;
      }
    }, (rejectResponse) => {
      return false;
    });
  }

  pendoTrack(formName) {
    if (formName == "1" || formName == null)
      return;

    let url = "/Office/PendoTrack";
    let postData = {
      formName: formName
    }
    return this.http.post(url, postData).toPromise();
  }
}
